import React from "react";
import { Table } from "reactstrap";
import "./style.scss"; // Import SCSS file

const TrainingDataTable: React.FC = () => {
  const headers = [
    {
      key: "total",
      value: "2022-23  Data for reference (in %) (updated as of Mar 2023)",
    },
    { key: "apr", value: "As on (4/23)" },
    { key: "may", value: "As on (5/23)" },
    { key: "jun", value: "As on (6/23)" },
    { key: "jul", value: "As on (7/23)" },
    { key: "aug", value: "As on (8/23)" },
    { key: "sep", value: "As on (9/23)" },
    { key: "oct", value: "As on (10/22)" },
    { key: "nov", value: "As on (11.1)" },
    { key: "dec", value: "As on (12/22)" },
    { key: "jan", value: "As on (01/1)" },
    { key: "feb", value: "As on (02/23)" },
    { key: "mar", value: "As on (03/23)" },
  ];

  const sbus = ["overall", "SBU-1", "SBU-2", "South", "North", "ETB"];

  const levels = [
    { name: "Pre-Foundational", moveTo: "Moved to Foundational" },
    { name: "Foundational", moveTo: "Moved to Advanced" },
    { name: "Advanced", moveTo: "Moved to Expert" },
    { name: "Expert", moveTo: null }, // No move row for Expert
  ];

  const jsonData = {
    overall: {
      total: {
        total: "120",
        apr: "112",
        may: "10",
        jun: "10",
        jul: "10",
        aug: "10",
        sep: "10",
        oct: "10",
        nov: "10",
        dec: "10",
        jan: "10",
        feb: "10",
        mar: "10",
      },
      "Pre-Foundational": {
        added: {
          total: "120",
          apr: "1",
          may: "1",
          jun: "1",
          jul: "1",
          aug: "1",
          sep: "1",
          oct: "1",
          nov: "1",
          dec: "1",
          jan: "1",
          feb: "1",
          mar: "1",
        },
        separated: {
          total: "120",
          apr: "1",
          may: "1",
          jun: "1",
          jul: "1",
          aug: "1",
          sep: "1",
          oct: "1",
          nov: "1",
          dec: "1",
          jan: "1",
          feb: "1",
          mar: "1",
        },
        total: {
          apr: "10",
          may: "10",
          jun: "10",
          jul: "10",
          aug: "10",
          sep: "10",
          oct: "10",
          nov: "10",
          dec: "10",
          jan: "10",
          feb: "10",
          mar: "10",
          total: "120",
        },
        certified: {
          total: "120",
          apr: "90",
          may: "90",
          jun: "90",
          jul: "90",
          aug: "90",
          sep: "90",
          oct: "90",
          nov: "90",
          dec: "90",
          jan: "90",
          feb: "90",
          mar: "90",
        },
      },
    },
  };

  const generateTableData = () => {
    const tableData: {
      sNo: string;
      sbu?: string;
      dataHead: string;
      isHeader?: boolean;
      key?: string;
      levelKey?: string;
      sbuKey?: string;
      isSubHeader?: boolean;
    }[] = [];

    let sbuCounter = 0;

    sbus.forEach(sbu => {
      const sbuSNo = `1.${sbuCounter}`;
      tableData.push({
        sNo: sbuSNo,
        sbu,
        dataHead: sbu === "overall" ? "Service" : null,
        isHeader: true,
        key: "overall",
        levelKey: "total",
        sbuKey: sbu,
      });

      let levelCounter = 1;

      levels.forEach(level => {
        const levelSNo = `${sbuSNo}.${levelCounter}`;
        tableData.push({
          sNo: levelSNo,
          dataHead: `${level.name} (Nos.)`,
          sbuKey: sbu,
          levelKey: level.name,
          key: "total",
          isSubHeader: true,
        });

        const subDataHeads = [
          { key: "added", value: "Added" },
          { key: "separated", value: "Separated" },
          { key: "total", value: "Total Headcount (MT1 to MT8)" },
          { key: "certified", value: `${level.name} Certified %` },
        ];

        if (level.moveTo) {
          subDataHeads.splice(2, 0, { key: "moved", value: level.moveTo });
        }

        subDataHeads.forEach(dataHead => {
          tableData.push({
            sNo: "",
            dataHead: dataHead.value,
            key: dataHead.key,
            levelKey: level.name,
            sbuKey: sbu,
          });
        });

        levelCounter++;
      });

      sbuCounter++;
    });

    return tableData;
  };

  const tableData = generateTableData();

  const getMonthData = (sbu, isHeader, monthKey, levelKey, key) => {
    if (isHeader) {
      return jsonData?.[sbu]?.[levelKey]?.[monthKey] ?? "-";
    }

    return jsonData?.[sbu]?.[levelKey]?.[key]?.[monthKey] ?? "-";
  };

  return (
    <div className="table-container">
      <Table className="training-table">
        <thead>
          <tr>
            <th rowSpan={2}>S.No</th>
            <th rowSpan={2}>SBU</th>
            <th rowSpan={2}>Data Heads</th>
            {headers.map((header, index) => (
              <th key={index}>{header.value}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tableData.map((row, index) => (
            <tr key={index} className={row.isHeader ? "table-header" : ""}>
              <td>{row.sNo}</td>
              <td className={row.sbu ? "highlighted fw-bold" : ""}>
                {row.sbu || ""}
              </td>
              <td className={row.isSubHeader ? "fw-bold" : ""}>
                {row.dataHead}
              </td>
              {headers.map((header, i) => (
                <td key={i}>
                  {getMonthData(
                    row.sbuKey,
                    row.isHeader,
                    header.key,
                    row.levelKey,
                    row.key
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TrainingDataTable;
